import Button from '@mui/material/Button';
import { styled, ThemeProvider } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import { yellowButtonTheme } from '@/app/styles/muiTheme';
import type { ButtonProps } from '@mui/material/Button';
import type { ReactNode } from 'react';

// Styled Button using MUI v5
const StyledButton = styled(Button)({
  borderRadius: '1rem',
  fontSize: '2rem',
  margin: '.5rem 0',
  height: '5rem',
});

interface ClassNamesProps extends ButtonProps {
  children?: ReactNode;
  className?: string;
}

export const ClassNames: React.FC<ClassNamesProps> = ({
  children,
  className,
  ...other
}) => {
  return (
    <ThemeProvider theme={yellowButtonTheme}>
      <StyledButton className={clsx(className)} {...other}>
        {children || 'class names'}
      </StyledButton>
    </ThemeProvider>
  );
};

ClassNames.displayName = 'ClassNames';

export default ClassNames;
